import { render, staticRenderFns } from "./VisualizarImagem.vue?vue&type=template&id=3a88de30&scoped=true&"
import script from "./VisualizarImagem.vue?vue&type=script&lang=js&"
export * from "./VisualizarImagem.vue?vue&type=script&lang=js&"
import style0 from "./VisualizarImagem.vue?vue&type=style&index=0&id=3a88de30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a88de30",
  null
  
)

export default component.exports